import React from "react";
import { OverlayTrigger, Tooltip, Button } from "react-bootstrap";
import DataTable from "react-data-table-component";
import { BsSliders } from "react-icons/bs";
import { longDateString } from "../../utils";
import "bootstrap/dist/css/bootstrap.min.css";

const DeviceProfilesListingView = ({
    profiles = [],
    selectedRows = [],
    onSelectedRowsChange = () => {},
    onEdit = () => {},
    onDelete = () => {},
    onConfigure = () => {},
    toggleCleared,
    noDataComponent,
    onRowClicked,
    onSort,
}) => {
    // `profiles` is the current page, searched and sorted on the server; the page's
    // Paginator handles paging, so the table's own pager is off.
    const columns = [
        {
            name: "Name",
            selector: (row) => row.name,
            sortable: true,
            sortField: "name",
            width: "250px",
        },
        {
            name: "Description",
            selector: (row) => row.description || "-",
            sortable: true,
            sortField: "description",
            wrap: true,
        },
        {
            name: "Actions",
            cell: (row) => (
                <Button
                    variant="primary"
                    size="sm"
                    onClick={(e) => {
                        e.stopPropagation();
                        onConfigure(row);
                    }}
                    style={{ whiteSpace: "nowrap" }}
                >
                    <BsSliders className="mr-2" />
                    Configure
                </Button>
            ),
            width: "160px",
            center: true,
        },
        {
            name: "Activity",
            selector: (row) => row.updated_at,
            sortable: true,
            sortField: "updated_at",
            width: "250px",
            cell: (row) => (
                <OverlayTrigger
                    placement="top"
                    overlay={
                        <Tooltip>
                            <div>
                                Created by {row.created_by?.name || "Unknown"}{" "}
                                at {longDateString(row.created_at)}
                            </div>
                            <div>
                                Modified by {row.updated_by?.name || "Unknown"}{" "}
                                at {longDateString(row.updated_at)}
                            </div>
                        </Tooltip>
                    }
                >
                    <div style={{ fontSize: "0.85rem" }}>
                        {row.updated_by?.name || "Unknown"} at{" "}
                        {longDateString(row.updated_at)}
                    </div>
                </OverlayTrigger>
            ),
        },
        {
            name: "Status",
            width: "90px",
            cell: (r) => (
                <span className={`badge bg-${r.is_active ? "success" : "secondary"}`}>
                    {r.is_active ? "Active" : "Inactive"}
                </span>
            ),
        },
    ];

    const conditionalRowStyles = [
        { when: (r) => !r.is_active, style: { opacity: 0.5, backgroundColor: "#f8f9fa" } },
    ];

    return (
        <div>
            <DataTable
                columns={columns}
                data={profiles}
                keyField="id"
                selectableRows
                onSelectedRowsChange={onSelectedRowsChange}
                selectedRows={selectedRows}
                // Selection is per page: the parent flips toggleCleared on page change
                // (and after bulk actions), which resets the table's own selection.
                clearSelectedRows={toggleCleared}
                sortServer
                onSort={(column, direction) =>
                    onSort?.(column.sortField ? { field: column.sortField, direction } : null)
                }
                striped
                highlightOnHover
                pointerOnHover
                onRowClicked={(row) => onRowClicked?.(row)}
                responsive
                noDataComponent={noDataComponent}
                conditionalRowStyles={conditionalRowStyles}
            />
        </div>
    );
};

export default DeviceProfilesListingView;
